module.exports = __webpack_public_path__ + "static/media/salesforcePlug2x.98dd374e.png";